import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { exportFile, showError } from "../../../utils/utilities";
import { useFormik } from "formik";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { fileFormatXextension } from "../../../utils/properties";
import { Col, Row, Select } from "antd";
import { DownloadOutlined, ClearOutlined } from "@ant-design/icons";
import Button from "../../../components/functional_components/Button/PFButton";
import { setLoading } from "../../../redux/ducks/Loading";
import Vertical from "../../../services/api/Vertical";
import ProjectEstimateStatus from "../../../services/api/ProjectEstimateStatus";
import ExportKpi from "../../../services/api/ExportKpi";

const KpiReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [state, setState] = useState({
    suppliersOptionsList: [],
    filterLoading: false,
    verticalsList: [],
    statusList: [],
  });

  useEffect(() => {
    getVerticalsList();
    getStatusList();
  }, []);

  const getStatusList = async () => {
    const statuses = await ProjectEstimateStatus.getStatusesList("allPages=true");
    const optionList = [];
    if (!statuses.errors && statuses.data) {
      statuses.data.forEach((status) => {
        optionList.push({ value: status.id, label: status.name });
      });
      setState((prevState) => ({
        ...prevState,
        statusList: optionList,
      }));
    } else {
      showError(get(statuses, "error.messageCode", "ER000"));
    }
  };

  const getVerticalsList = async () => {
    const verticals = await Vertical.getVerticalList("allPages=true");
    const optionList = [];
    if (!verticals.error && verticals.data) {
      verticals.data.forEach((status) => {
        optionList.push({ value: status.id, label: status.name });
      });
      setState((prevState) => ({
        ...prevState,
        verticalsList: optionList,
      }));
    } else {
      showError(get(verticals, "error.messageCode", "ER000"));
    }
  };

  const formikFilter = useFormik({
    initialValues: {
      verticalIds: [],
      projectStatusEstimateIds: [],
      projectStatus: [],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      const obj = {
        projectStatusEstimateIds: values.projectStatusEstimateIds,
        verticalIds: values.verticalIds,
        projectStatus: values.projectStatus,
      };
      const exportResponse = await ExportKpi.exportKpi(obj);
      if (!exportResponse.error) {
        const downloadType = fileFormatXextension["xlsx"];
        const blob = new Blob([exportResponse], { type: downloadType });
        exportFile(blob, "kpi-analysis.xlsx");
      } else {
        showError(get(exportResponse, "error.messageCode", "ER000"));
      }
      dispatch(setLoading(false));
    },
  });

  return (
    <div className="filter-container">
      <Row type="flex" justify="start">
        <Col lg={6} md={12} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mb-10" htmlFor="vertical">
              {t("reportCP.filter.vertical")}
            </label>
          </Row>
          <Row>
            <Col span={20}>
              <Select
                mode="multiple"
                className="w-100"
                id="verticalIds"
                name="verticalIds"
                placeholder={t("reportCP.filter.vertical")}
                onChange={(value) => formikFilter.setFieldValue("verticalIds", value)}
                onBlur={formikFilter.handleBlur("verticalIds")}
                value={formikFilter.values.verticalIds}
                options={state.verticalsList}
              />
            </Col>
          </Row>
        </Col>

        <Col lg={6} md={12} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mb-10" htmlFor="projectStatusEstimateIds">
              {t("reportCP.filter.status")}
            </label>
          </Row>
          <Row>
            <Col span={20}>
              <Select
                mode="multiple"
                id="projectStatusEstimateIds"
                name="projectStatusEstimateIds"
                placeholder={t("reportCP.filter.status")}
                className="w-100"
                onChange={(value) => formikFilter.setFieldValue("projectStatusEstimateIds", value)}
                onBlur={formikFilter.handleBlur("projectStatusEstimateIds")}
                value={formikFilter.values.projectStatusEstimateIds}
                options={state.statusList}
              />
            </Col>
          </Row>
        </Col>

        <Col lg={6} md={12} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mb-10" htmlFor="projectStatus">
              {t("reportCP.filter.projectStatus")}
            </label>
          </Row>
          <Row>
            <Col span={20}>
              <Select
                mode="multiple"
                id="projectStatus"
                name="projectStatus"
                placeholder={t("reportCP.filter.projectStatus")}
                className="w-100"
                onChange={(value) => formikFilter.setFieldValue("projectStatus", value)}
                onBlur={formikFilter.handleBlur("projectStatus")}
                value={formikFilter.values.projectStatus}
                options={[
                  { label: t("projectsManagement.filter.select.all"), value: "" },
                  { label: t("projectsManagement.filter.select.blocked"), value: "BLOCKED" },
                  { label: t("projectsManagement.filter.select.closed"), value: "CLOSED" },
                  { label: t("projectsManagement.filter.select.completed"), value: "COMPLETED" },
                  { label: t("projectsManagement.filter.select.created"), value: "CREATED" },
                  { label: t("projectsManagement.filter.select.planning"), value: "PLANNING" },
                  { label: t("projectsManagement.filter.select.released"), value: "RELEASED" },
                  { label: t("projectsManagement.filter.select.unknown"), value: "UNKNOWN" },
                ]}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-1em" justify="end">
        <Col>
          <Button
            type="secondary"
            currentSize="large"
            clickCallback={formikFilter.resetForm}
            currentIcon={<ClearOutlined className="icon-large" />}
          />
        </Col>
        <Col className="left-margin">
          <Button
            currentSize="large"
            isLoading={state.filterLoading}
            clickCallback={formikFilter.submitForm}
            currentIcon={<DownloadOutlined className="icon-large" />}
          />
        </Col>
      </Row>
    </div>
  );
};

export default KpiReport;
